// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ChevronDown, BarChart2 } from 'react-feather'
import _ from 'lodash'
import ReactCSSTransitionGroup from 'react-transition-group'
import { change } from 'redux-form'

// CSS
import './styles.scss'

// Components/Containers
import Breadcrumb from '../../components/Breadcrumb'
import Filters from '../../components/Filters'
import Links from '../../components/Links'
import NotFoundBox from '../../components/NotFoundBox'
import Pagination from '../../components/Pagination'
import Shout from '../../components/Shout'
import LoadingBox from '../../components/LoadingBox'
import CaptureExport from './components/CaptureExport'
import CaptureCardCase from './components/CaptureCardCase'
import CaptureCardConfirm from './components/CaptureCardConfirm'
import CaptureCardDocument from './components/CaptureCardDocument'
import CaptureCardInsert from './components/CaptureCardInsert'
import CaptureFilter from './components/CaptureFilter'

// Actions
import { changeOrderBy, changeFilters, changeLawsuitSelected, saveField, loadFields, fetchLawsuits, updateLawsuit, fetchLawyer, changeCardType, changeField, changeLoading, changeVisible, changeExportModelSelected, fetchCaptureClassifiers, fetchCaptureLawFirms, insertCase, validateForm, changeExportCases, changeTotal, changeOffset, downloadFiles } from './actions'

// Constants
import { formatDate } from '../../constants/others'

// Imgs
import notFoundImg from '../../assets/not-found.svg'

class Capture extends Component {
  state = { intervalId: 0 }

  componentDidMount() {
    const { total, offset, perPage, fetchLawsuits, fetchCaptureClassifiers, fetchCaptureLawFirms } = this.props

    fetchLawsuits(null, null, null, total, offset, perPage, 'first')
    fetchCaptureClassifiers()
    fetchCaptureLawFirms()
  }

  componentWillUpdate(nextProps) {
    const { captureFilter } = this.props
    const { captureFilter: nextCaptureFilter, fetchLawsuits, total, offset, perPage } = nextProps
    const { intervalId } = this.state

    if (!captureFilter || !_.isEqual(captureFilter.values, nextCaptureFilter.values)) {
      fetchLawsuits(nextCaptureFilter.values, null, null, total, offset, perPage, 'first')

      clearInterval(intervalId)

      const interval = setInterval(() => {
        fetchLawsuits(nextCaptureFilter.values, null, null, total, offset, perPage, 'first', false)
      }, 60000)

      this.setState({ intervalId: interval })
    }
  }

  componentWillUnmount() {
    const { changeTotal, changeOffset } = this.props
    const { intervalId } = this.state

    clearInterval(intervalId)

    changeTotal(0)
    changeOffset(0)
  }

  exportModel = (exportModelSelected, exportCases) => {
    const { captureFilter, fetchLawsuits, lawsuitSelected } = this.props

    switch (exportModelSelected) {
      case "Com Acordo":
        fetchLawsuits(captureFilter.values, true, (exportCases === "all") ? '' : lawsuitSelected)
        break
      default:
        break
    }
  }

  render() {
    const { columns, orderBy, filters, lawsuitSelected, changeLawsuitSelected, lawsuits, forms, visible, loading, captureFilter, exportModelSelected, change, cardType, changeOrderBy, changeField, saveField, loadFields, fetchLawyer, fetchLawsuits, changeCardType, changeVisible, changeExportModelSelected, validateForm, insertCase, exportCases, changeExportCases, total, offset, perPage, downloadFiles } = this.props
    const { exportModel } = this
    return (
      <div className="capture">
        <div className="capture__header">
          <Breadcrumb marginBottom={0} routes={['Captação']} />
          <span
            className={loading._export ?
              "capture__export capture__export--loading" :
              "capture__export"}
            onClick={() => {
              !loading._export && changeVisible("_export", true)
              changeExportCases("all")
            }}>
            Exportar Processos
          </span>
        </div>
        {/* <div className="capture__sub-header">
          <p className="capture__result">{lawsuits.length} processos encontrados</p>
        </div> */}
        <Pagination
          page="meus-casos"
          total={total}
          offset={offset}
          perPage={perPage}
          leftActionIsVisible={visible.filters}
          loading={loading.page}
          onSelect={action => {
            action === 'Filtrar' ?
              changeVisible('filters', !visible.filters) :
              fetchLawsuits(captureFilter.values, null, null, total, offset, perPage, action)
          }} />
        <Shout><BarChart2 size={17} /> Nosso algoritmo determina o melhor advogado, dentre os captados, para negociar um acordo.</Shout>
        <div className="capture__content">
          <div className="capture__rows">
            {columns.map(column => (
              <div
                key={column.value}
                className={orderBy.value === column.value ? 'capture__column capture__column--green' : 'capture__column'}
                onClick={() => changeOrderBy(column.value, column.order)}>
                {column.label} <ChevronDown size={14} />
              </div>
            ))}
          </div>
          {loading.page &&
            <LoadingBox />
          }
          {!loading.page && _.isEmpty(lawsuits) &&
            <NotFoundBox
              img={notFoundImg}
              title="Não encontramos nenhum processo no momento."
              text="Estamos monitorando constantemente todos os tribunais." />
          }
          {!loading.page && _.orderBy(lawsuits, [orderBy.value], orderBy.order)
            .map(item => {
              return (
                <div
                  key={item.number}
                  className={
                    lawsuitSelected === item.number ?
                      "capture__rows capture__rows--selected" :
                      "capture__rows"
                  }
                  onClick={() => lawsuitSelected !== item.number && loadFields(forms[0], item, lawsuitSelected)}>
                  {(!lawsuitSelected || lawsuitSelected !== item.number) && columns.map(column => (
                    <div
                      key={column.value}
                      className="capture__column">
                      <span>{(column.format) ? column.format(item[column.value]) : (item[column.value]) ? item[column.value] : '-'}</span>
                    </div>
                  ))}
                  {(!lawsuitSelected || lawsuitSelected !== item.number) && !item.viewed &&
                    <div className="capture__viewed">
                      <span />
                    </div>
                  }
                  {lawsuitSelected === item.number && (
                    <ReactCSSTransitionGroup
                      transitionName="capture"
                      transitionAppear={true}
                      transitionLeave={true}
                      transitionEnter={false}
                      transitionAppearTimeout={5000}
                      transitionLeaveTimeout={5000}>
                      {cardType === 'case' ?
                        <CaptureCardCase
                          lawsuit={item}
                          form={forms[0]}
                          changeLawsuitSelected={changeLawsuitSelected}
                          changeCardType={changeCardType}
                          changeField={changeField}
                          saveField={saveField}
                          fetchLawyer={fetchLawyer}
                          validateForm={validateForm}
                          changeVisible={changeVisible}
                          changeExportCases={changeExportCases}
                        /> :
                        cardType === 'insert' ?
                          <CaptureCardInsert
                            form={forms[1]}
                            forms={forms}
                            changeCardType={changeCardType}
                            changeField={changeField}
                            insertCase={insertCase}
                            loading={loading.insert}
                          /> :
                          cardType === 'documents' ?
                            <CaptureCardDocument
                              documents={item.documents}
                              changeCardType={changeCardType}
                              downloadFiles={() => downloadFiles(item.number)}
                              loading={loading.download}
                            /> :
                            <CaptureCardConfirm
                              lawsuit={item}
                              type={cardType}
                            />
                      }
                    </ ReactCSSTransitionGroup>
                  )}
                </div>
              )
            })
          }
        </div>
        <CaptureFilter
          handleReset={(section) => change('captureFilter', section, '')}
          handleOpen={() => changeVisible("filters", true)}
          handleClose={() => changeVisible("filters", false)}
          captureFilter={captureFilter}
          visible={visible.filters}
        />
        <CaptureExport
          visible={visible._export}
          exportModelSelected={exportModelSelected}
          changeVisible={changeVisible}
          changeExportModelSelected={changeExportModelSelected}
          exportModel={exportModel}
          loading={loading._export}
          exportCases={exportCases}
        />
      </div>
    )
  }
}

Capture = connect(
  (state, ownProps) => ({
    captureFilter: state.form.captureFilter,
    user: state.auth.user,
    columns: state.capture.columns,
    orderBy: state.capture.orderBy,
    filters: state.capture.filters,
    lawsuitSelected: state.capture.lawsuitSelected,
    lawsuits: state.capture.lawsuits,
    forms: state.capture.forms,
    visible: state.capture.visible,
    loading: state.capture.loading,
    cardType: state.capture.cardType,
    exportModelSelected: state.capture.exportModelSelected,
    lawFirms: state.capture.lawFirms,
    companies: state.capture.companies,
    exportCases: state.capture.exportCases,
    total: state.capture.total,
    offset: state.capture.offset,
    perPage: state.capture.perPage
  }), { changeOrderBy, changeFilters, changeLawsuitSelected, changeField, saveField, loadFields, fetchLawsuits, updateLawsuit, fetchLawyer, change, changeCardType, changeVisible, changeLoading, changeExportModelSelected, fetchCaptureClassifiers, fetchCaptureLawFirms, insertCase, validateForm, changeExportCases, changeTotal, changeOffset, downloadFiles })(Capture)

export default Capture
